import { render, staticRenderFns } from "./ResourceAttribute.vue?vue&type=template&id=418b2307&scoped=true"
import script from "./ResourceAttribute.vue?vue&type=script&lang=js"
export * from "./ResourceAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b2307",
  null
  
)

export default component.exports